import Icon from '../icons/icon/icon';
import { POLICY_RULE_CATEGORY } from '../../pages/policies/policy-types';
import IconPolicyGroupExchange from "../../components/icons/icon-policy-group-exchange/icon-policy-group-exchange";
import IconPolicyGroupOrderModification from "../../components/icons/icon-policy-group-order-modification/icon-policy-group-order-modification";
import IconPolicyGroupReturn from "../../components/icons/icon-policy-group-return/icon-policy-group-return";

interface IProps {
    category: POLICY_RULE_CATEGORY;
}

const POLICY_RULE_CATEGORY_TO_ICON_MAP = {
    [POLICY_RULE_CATEGORY.ORDER_MODIFICATION]: IconPolicyGroupOrderModification,
    [POLICY_RULE_CATEGORY.EXCHANGE]: IconPolicyGroupExchange,
    [POLICY_RULE_CATEGORY.RETURN]: IconPolicyGroupReturn,
}

export const PolicyRuleCategoryIcon: React.FC<IProps> = ({ category }) => (
    <Icon Component={POLICY_RULE_CATEGORY_TO_ICON_MAP[category]} />
);
